import React from 'react'

function MainBannerBlue({text}) {
 
  return (
    <div className="w-full h-48 md:h-80 bg-blueGradient">
      <h1 className="text-white text-center font-light text-4xl pt-28 lg:pt-20 md:pt-52">{text}</h1>
    </div>
  )
}

export default MainBannerBlue;